import { render, staticRenderFns } from "./BaseItemCompetitionIconPhoto.vue?vue&type=template&id=46eca3cc&scoped=true&"
import script from "./BaseItemCompetitionIconPhoto.vue?vue&type=script&lang=js&"
export * from "./BaseItemCompetitionIconPhoto.vue?vue&type=script&lang=js&"
import style0 from "./BaseItemCompetitionIconPhoto.vue?vue&type=style&index=0&id=46eca3cc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46eca3cc",
  null
  
)

export default component.exports